package com.zi.support.shared

/**
 * Companies added in Settings (the `companies` collection: document id + companyName), so the ticket and record
 * pickers offer them and their tickets file under that document id. Each app loads them once after sign-in.
 */
object CompanyDirectory {
    private var saved: List<Pair<String, String>> = emptyList()

    /** [ids] and [names] line up: one entry per `companies` document that has a companyName. */
    fun load(ids: List<String>, names: List<String>) {
        saved = ids.zip(names).filter { (id, name) -> id.isNotBlank() && name.isNotBlank() }.map { (id, name) -> id to name.trim() }
    }

    /** The Settings document id for a company name, if one was added there under that name. */
    fun savedId(name: String): String? = saved.firstOrNull { it.second.equals(name.trim(), ignoreCase = true) }?.first

    /** [builtIn] plus Settings companies whose id none of them already files under, A-Z. */
    fun names(builtIn: List<String>): List<String> {
        val known = builtIn.map { IncidentFilters.companyId(it) }.toSet()
        return (builtIn + saved.filter { it.first !in known }.map { it.second }).distinctBy { it.lowercase() }.sortedBy { it.lowercase() }
    }
}
